import { Component, OnInit } from '@angular/core';
import {NGXLogger} from "ngx-logger";
import {FacadeService} from "../../shared/services/facade.service";

@Component({
  selector: 'app-logs-system',
  templateUrl: './logs-system.component.html',
  styleUrls: ['./logs-system.component.css']
})
export class LogsSystemComponent implements OnInit {

  /**
   * Constructor
   * @param logger Logger instance
   * @param facadeService Facade instance
   */
  constructor(private logger: NGXLogger,
              private facadeService: FacadeService) {
    this.facadeService.setPageTitleContext("System Logs");
  }

  /**
   * Init
   */
  ngOnInit(): void {
  }

}
